/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refresh_With_Time_CrystalsInputs */

const en_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only items you haven’t unlocked will appear. The next daily refresh will still happen at its scheduled time.`)
};

const ar_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ستظهر فقط المنتجات التي لم تفتحها بعد. وسيجري التحديث اليومي التالي في موعده المحدد كالمعتاد.`)
};

const de_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es erscheinen nur Artikel, die du noch nicht freigeschaltet hast. Die nächste tägliche Aktualisierung findet weiterhin zur geplanten Zeit statt.`)
};

const es_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo aparecerán artículos que aún no hayas desbloqueado. La próxima actualización diaria seguirá realizándose a la hora prevista.`)
};

const fr_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuls les articles que vous n’avez pas encore débloqués apparaîtront. La prochaine actualisation quotidienne aura toujours lieu à l’heure prévue.`)
};

const it_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appariranno solo gli articoli che non hai ancora sbloccato. Il prossimo aggiornamento giornaliero avverrà comunque all’orario previsto.`)
};

const ja_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだアンロックしていない商品のみが表示されます。毎日の定時更新は、予定どおりに行われます。`)
};

const ko_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 잠금 해제하지 않은 상품만 표시됩니다. 다음 일일 새로고침은 예정된 시간에 그대로 진행됩니다.`)
};

const pt_br_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só aparecerão itens que você ainda não desbloqueou. A próxima atualização diária acontecerá normalmente no horário previsto.`)
};

const ru_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Появятся только товары, которые вы ещё не разблокировали. Следующее ежедневное обновление произойдёт в запланированное время.`)
};

const th_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จะแสดงเฉพาะสินค้าที่ยังไม่ได้ปลดล็อกเท่านั้น การรีเฟรชรายวันครั้งถัดไปจะยังคงเกิดขึ้นตามเวลาที่กำหนดไว้`)
};

const tr_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca henüz kilidini açmadığın ürünler görünür. Bir sonraki günlük yenileme yine planlanan saatte gerçekleşir.`)
};

const zh_cn_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新后只会出现尚未解锁的商品，另外，原定的每日刷新时间仍会再次刷新商品。`)
};

const zh_tw_refresh_with_time_crystals = /** @type {(inputs: Refresh_With_Time_CrystalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新後只會出現尚未解鎖的商品，另外，原定的每日刷新時間仍會再次刷新商品。`)
};

/**
* | output |
* | --- |
* | "Only items you haven’t unlocked will appear. The next daily refresh will still happen at its scheduled time." |
*
* @param {Refresh_With_Time_CrystalsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const refresh_with_time_crystals = /** @type {((inputs?: Refresh_With_Time_CrystalsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refresh_With_Time_CrystalsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refresh_with_time_crystals(inputs)
	if (locale === "ar") return ar_refresh_with_time_crystals(inputs)
	if (locale === "de") return de_refresh_with_time_crystals(inputs)
	if (locale === "es") return es_refresh_with_time_crystals(inputs)
	if (locale === "fr") return fr_refresh_with_time_crystals(inputs)
	if (locale === "it") return it_refresh_with_time_crystals(inputs)
	if (locale === "ja") return ja_refresh_with_time_crystals(inputs)
	if (locale === "ko") return ko_refresh_with_time_crystals(inputs)
	if (locale === "pt_br") return pt_br_refresh_with_time_crystals(inputs)
	if (locale === "ru") return ru_refresh_with_time_crystals(inputs)
	if (locale === "th") return th_refresh_with_time_crystals(inputs)
	if (locale === "tr") return tr_refresh_with_time_crystals(inputs)
	if (locale === "zh_cn") return zh_cn_refresh_with_time_crystals(inputs)
	return zh_tw_refresh_with_time_crystals(inputs)
});